(() => {
  let active = null;
  let opener = null;
  let observer = null;
  const focusable = modal => [...modal.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(node => node.getClientRects().length);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-designer-size-guide-opener]');
    if (!trigger) return;
    requestAnimationFrame(() => {
      const modal = document.getElementById(trigger.getAttribute('aria-controls'));
      const guide = modal && modal.querySelector('[data-designer-size-guide]');
      if (!modal || !guide || !modal.classList.contains('modal--active')) return;
      if (observer) observer.disconnect();
      active = modal;
      opener = trigger;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', guide.dataset.sizeGuideTitle);
      modal.setAttribute('aria-hidden', 'false');
      modal.setAttribute('tabindex', '-1');
      const close = modal.querySelector('.js-modal-close');
      if (close) close.setAttribute('aria-label', guide.dataset.sizeGuideClose);
      (close || modal).focus({preventScroll: true});
      observer = new MutationObserver(() => {
        if (modal.classList.contains('modal--active')) return;
        modal.setAttribute('aria-hidden', 'true');
        active = null;
        observer.disconnect();
        if (opener && opener.isConnected) opener.focus({preventScroll: true});
      });
      observer.observe(modal, {attributes: true, attributeFilter: ['class']});
    });
  });
  document.addEventListener('keydown', event => {
    if (!active || event.key !== 'Tab') return;
    const nodes = focusable(active);
    if (!nodes.length) { event.preventDefault(); active.focus(); return; }
    const first = nodes[0], last = nodes[nodes.length - 1];
    if (event.shiftKey && (document.activeElement === first || !active.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !active.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });
})();
